import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {MANAGE_ROLE, MANAGE_ROLE_API_URL, GET_ALL_MANAGE_ROLE_API_URL} from 'constants/AppConstants';
import { USER_All_INFORMATION } from "constants/AuthConstant";
import CommonService from 'services/CommonService/CommonService';
import IntlMessage from "components/util-components/IntlMessage";
const setLocale = (localeKey, isLocaleOn = true) =>
  isLocaleOn ? <IntlMessage id={localeKey} /> : localeKey.toString();
const permission = JSON.parse(localStorage.getItem(USER_All_INFORMATION));

export const initialState = {
  ManageRoleErrors       : {},
  permission: permission?.manage_role ?? [],
  ManageRoleShowMessage  : null,
  ManageRoleResult       : [],
  ManageRoleButtonSpinner : false,
  ManageRoleTableLoading : true,
  ManageRoleAddDrawer    : false,
  ManageRoleEditData     : [],
  ManageRoleButtonAndModelLabel  : setLocale('managerole.add'),
  tablePagination: {
        current: 1,
        pageSize: 10,
        total: 0,
    },
    sorting: {},
    filter: {},
    ViewManageRoleData: [],
    ViewManageRoleLoader: true,
    DrawerStatus: 0,
};

export const createManageRole = createAsyncThunk(
    "createManageRole",
  async (data) => {
    try {
      const response = await CommonService.createAndUpdate(data, MANAGE_ROLE_API_URL);
      return response;
    } catch (err) {
      throw new Error(JSON.stringify(err.response.data.errors)); // Throw an error with the server response errors
    }
  }
);

export const getManageRole = createAsyncThunk(
    "getManageRole",
  async (data) => {
    try {
      const response = await CommonService.getAllPost(data, GET_ALL_MANAGE_ROLE_API_URL);
      return response;
    } catch (err) {
      throw new Error(JSON.stringify(err.response.data.errors)); // Throw an error with the server response errors
    }
  }
);

export const viewManageRole = createAsyncThunk(
  "viewManageRole",
  async (id) => {
    try {
      const response = await CommonService.showOne(id, MANAGE_ROLE_API_URL);
      return response;
    } catch (err) {
      throw new Error(JSON.stringify(err.response.data.errors)); // Throw an error with the server response errors
    }
  }
);

export const deleteManageRole = createAsyncThunk(
  "deleteManageRole",
  async (data) => {
    try {
      const response = await CommonService.deleteOne(data, MANAGE_ROLE_API_URL);
      return response;
    } catch (err) {
      throw new Error(JSON.stringify(err.response.data.errors)); // Throw an error with the server response errors
    }
  }
);

export const manageManageRoleSlice = createSlice({
  name: MANAGE_ROLE,
  initialState,
  reducers: {
    onCloseError: (state, action) => {
      state.ManageRoleErrors = {};
    },
    ManageRoleAddDrawerStatus: (state, action) => {
        if (action.payload.status === false) {
            state.ManageRoleButtonSpinner = false;
      }
      state.ManageRoleAddDrawer   = action.payload.status;
      state.DrawerStatus = action.payload.errorStatus;
      state.ManageRoleEditData    = [];
      state.ManageRoleButtonAndModelLabel = setLocale('managerole.add');
    },
    ManageRoleEditWithDrawerStatus: (state, action) => {
      state.ManageRoleAddDrawer = true;
      state.DrawerStatus = action.payload.errorStatus;
      state.ManageRoleEditData = action.payload.data;
      state.ManageRoleButtonAndModelLabel = setLocale('managerole.edit');
    },
    updateSortFilters: (state, action) => {
        state.filter = action.payload.filter;
        state.sorting = action.payload.sorting;
    },
    setColumnSearch: (state, action) => {
      state.filter = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createManageRole.pending, (state, action) => {
        state.DrawerStatus = 0
        state.ManageRoleButtonSpinner = true;
      }).addCase(createManageRole.fulfilled, (state, action) => {
        state.DrawerStatus = 0
        state.ManageRoleButtonSpinner = false;
        state.ManageRoleErrors = {}
      }).addCase(createManageRole.rejected, (state, action) => {
        state.DrawerStatus = 1
        state.ManageRoleShowMessage = true;
        state.ManageRoleButtonSpinner = false;
        state.ManageRoleErrors = JSON.parse(action.error.message); // Parse the error messages and store them in the state
      }).addCase(getManageRole.pending, (state, action) => {
        state.ManageRoleButtonSpinner = true;
        state.ManageRoleTableLoading = true;
      }).addCase(getManageRole.fulfilled, (state, action) => {
        state.ManageRoleButtonSpinner = false;
        state.ManageRoleTableLoading = false;
        state.ManageRoleResult = action.payload;
        state.tablePagination = {
            ...state.tablePagination,
            total: action.payload.pagination.total,
            current: action.payload.pagination.current_page,
            pageSize: action.payload.pagination.per_page
        };
      }).addCase(getManageRole.rejected, (state, action) => {
        state.ManageRoleShowMessage = true; // Set the showMessage flag to display the errors
        state.ManageRoleButtonSpinner = false;
        state.ManageRoleTableLoading = false;
        state.ManageRoleErrors = JSON.parse(action.error.message); // Parse the error messages and store them in the state
      })
      .addCase(viewManageRole.pending, (state, action) => {
        state.ViewManageRoleLoader = true;
        state.ViewManageRoleData = [];
      }).addCase(viewManageRole.fulfilled, (state, action) => {
        state.ViewManageRoleLoader = false;
        state.ViewManageRoleData = action.payload;
      }).addCase(viewManageRole.rejected, (state, action) => {
        state.ViewManageRoleLoader = false;
        state.ViewManageRoleData = [];
      })
      .addCase(deleteManageRole.pending, (state, action) => {
        state.ManageRoleTableLoading = true;
      }).addCase(deleteManageRole.fulfilled, (state, action) => {
        state.ManageRoleTableLoading = false;
      }).addCase(deleteManageRole.rejected, (state, action) => {
        state.ManageRoleTableLoading = false;
      });
  },
});

export const { onCloseError, setColumnSearch, ManageRoleAddDrawerStatus, ManageRoleEditWithDrawerStatus, updateSortFilters } = manageManageRoleSlice.actions;

export default manageManageRoleSlice.reducer;